<template>
  <div class="home-rectification-mian">

    <div class="rectification-assemble">
      <div class="assemble-name">
        <span class="msg">已上报隐患</span>
        <div class="name-main">
          <span class="name">{{ newData.tbHiddenGovernCount && newData.tbHiddenGovernCount != '' ?
            newData.tbHiddenGovernCount :
            '0'
          }}</span>
          <span class="unit">个</span>
        </div>
      </div>
      <img class="assemble-ico" src="../../assets/homeNew/content4.png" />
    </div>

    <div class="schedule-title">已处理隐患 {{ newData.tbHiddenGovernReformCount && newData.tbHiddenGovernReformCount != '' ?
      newData.tbHiddenGovernReformCount : '0' }}个</div>
    <div class="schedule-rogress">
      <el-progress :stroke-width="19"
        :percentage="newData.tbHiddenGovernReformRatio && newData.tbHiddenGovernReformRatio != '' && !isNaN(Number(newData.tbHiddenGovernReformRatio)) ? parseNumber(Number(newData.tbHiddenGovernReformRatio) * 100) : 0"></el-progress>
    </div>


    <div class="schedule-title">待处理隐患 {{ newData.tbHiddenGovernNotReformCount && newData.tbHiddenGovernNotReformCount !=
      '' ?
      newData.tbHiddenGovernNotReformCount : '0' }}个</div>
    <div class="schedule-rogress schedule-rogress2">
      <el-progress :stroke-width="19"
        :percentage="newData.tbHiddenGovernNotReformRatio && newData.tbHiddenGovernNotReformRatio != '' && !isNaN(Number(newData.tbHiddenGovernNotReformRatio)) ? parseNumber(Number(newData.tbHiddenGovernNotReformRatio) * 100) : 0"></el-progress>
    </div>

    {{ showData }}
  </div>
</template>

<script>
import resize from './mixins/resize'
import { parseNumber } from '@/utils'
export default {
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      newData: {

      }
    }
  },
  computed: {
    showData() {
      this.newData = JSON.parse(JSON.stringify(this.item))
      this.newData.tbHiddenGovernCount = 0
      this.newData.tbHiddenGovernReformCount = 0
      this.newData.tbHiddenGovernReformRatio = 0
      this.newData.tbHiddenGovernNotReformCount = 0
      this.newData.tbHiddenGovernNotReformRatio = 0
      return ''
    }
  },
  watch: {

  },
  created() {
    setInterval(() => {
      this.newData.tbHiddenGovernCount = this.trendsHandle(this.newData.tbHiddenGovernCount, this.item.tbHiddenGovernCount)
      this.newData.tbHiddenGovernReformCount = this.trendsHandle(this.newData.tbHiddenGovernReformCount, this.item.tbHiddenGovernReformCount)
      this.newData.tbHiddenGovernReformRatio = this.trendsHandle(this.newData.tbHiddenGovernReformRatio, this.item.tbHiddenGovernReformRatio, 1)
      this.newData.tbHiddenGovernNotReformCount = this.trendsHandle(this.newData.tbHiddenGovernNotReformCount, this.item.tbHiddenGovernNotReformCount)
      this.newData.tbHiddenGovernNotReformRatio = this.trendsHandle(this.newData.tbHiddenGovernNotReformRatio, this.item.tbHiddenGovernNotReformRatio, 1)
    }, 50);
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    parseNumber(str) {
      return parseNumber(str)
    },
    // 动态处理
    trendsHandle(currentRate, rate, type) {
      if (!rate || rate == '' || isNaN(Number(rate))) {
        return 0
      }

      if (type == 1) {
        rate = parseNumber(Number(rate)) * 100
      } else {
        rate = parseNumber(Number(rate))
      }
      /*if (rate >= 100 && type == 1) {
        rate = 10
      }*/
      if (isNaN(Number(currentRate))) {
        currentRate = 0;
      } else {
        currentRate = parseNumber(Number(currentRate));
      }

      if (type == 1) {
        currentRate = currentRate * 100
      }

      if (currentRate < rate) {
        if (parseInt(rate) == currentRate) {
          currentRate = parseNumber(currentRate + (rate - parseInt(rate)));
        } else {
          currentRate = parseNumber(currentRate + 1);
        }


        return currentRate / (type == 1 ? 100 : 1)
      } else {
        return rate / (type == 1 ? 100 : 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-rectification-mian {
  width: 100%;

  .rectification-assemble {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .assemble-name {
      flex: 1;

      .msg {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        display: block;
        margin-bottom: 8px;
      }

      .name-main {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;

        .name {
          font-size: 52px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFCC01;
          line-height: 52px;
        }

        .unit {
          font-size: 22px;
          line-height: 22px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFCC01;
          margin-left: 5px;
          padding-bottom: 8px;
        }
      }

    }

    .assemble-ico {
      width: 126px;
      height: 145px;
      display: block;
    }
  }

  .schedule-title {
    width: 100%;
    font-size: 13px;
    line-height: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin: 16px 0 16px 0;
  }


}
</style>
<style lang="scss">
.schedule-rogress {
  width: 92%;
  height: 19px;
  margin-bottom: 35px;
  display: block;


  .el-progress__text {
    font-size: 16px !important;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-left: 20px;
  }

  /*.el-progress-bar__outer {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.3), rgba(130, 235, 255, 0.3), rgba(6, 150, 233, 0.3));
  }*/

  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.7), rgba(130, 235, 255, 0.7), rgba(6, 150, 233, 0.7));
  }
}

.schedule-rogress2 {
  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(219, 175, 0, 0.7), rgba(255, 239, 130, 0.7), rgba(227, 181, 0, 0.7));
  }
}
</style>